import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { chargingStationActions } from "stores/ChargingStationStore/chargingStationAction";
import { chargingStationApi } from "stores/ChargingStationStore/chargingStationApi";

const mapStateToProps = (state) => {
  return {
    ChargingStationSeeAllRequestList:state.chargingStation.ChargingStationSeeAllRequestList
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getChargingStationSeeAllRequest:chargingStationActions.getChargingStationSeeAllRequest,
    approveRejectApi: chargingStationApi.approveRejectApi

}, dispatch);

const ChargingRequestStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default ChargingRequestStore;
